import React, { useState } from 'react';
import "./KpiDefinitionStep.css"
import {KpiProps} from "../../../../../types/types";
import {Button, MantineTheme, Text} from "@mantine/core";
import {ArrayUtils} from "../../../../../utils/arrayUtils";
import { PrefillModal } from './modal/PrefillModal';


const KpiDefinitionStep: React.FC<KpiProps> = (props: KpiProps) => {

    const kpiInfo = props.kpiInfo;
    const [openKPIModal, setOpenKPIModal] = useState(false);


    const addKpiName = (event: { target: { value: React.SetStateAction<string>; }; }) => {
        const name = event.target.value as string;
        props.setKpiState(currentState => ({
            ...currentState,
            kpiInfo: {
                ...currentState.kpiInfo,
                name
            },
            validationErrors: currentState.validationErrors.filter(er => er.property !== 'name')
        }))
    }

    const addKpiDescription = (event: { target: { value: React.SetStateAction<string>; }; }) => {
        props.setKpiState(currentState => ({
            ...currentState,
            kpiInfo: {
                ...currentState.kpiInfo,
                description: event.target.value as string
            },
            validationErrors: currentState.validationErrors.filter(er => er.property !== 'description')
        }))
    }

    const addKpiOwner = (event: { target: { value: React.SetStateAction<string>; }; }) => {
        props.setKpiState(currentState => ({
            ...currentState,
            kpiInfo: {
                ...currentState.kpiInfo,
                owner: event.target.value as string
            },
            validationErrors: currentState.validationErrors.filter(er => er.property !== 'owner')
        }))
    }

    const addKpiDocumentation = (event: { target: { value: React.SetStateAction<string>; }; }) => {
        props.setKpiState(currentState => ({
            ...currentState,
            kpiInfo: {
                ...currentState.kpiInfo,
                extendedAttributes:{
                    ...currentState.kpiInfo.extendedAttributes,
                    documentation: event.target.value as string
                }
            },
            validationErrors: currentState.validationErrors.filter(er => er.property !== 'documentation')
        }))
    }
    

    const kpiName = kpiInfo.name || ''
    const description = kpiInfo.description || ''
    const documentation = (kpiInfo.extendedAttributes && kpiInfo.extendedAttributes.documentation) || ''
    const owner = kpiInfo.owner || ''

    const nameError = ArrayUtils.isNotEmpty(props.validationErrors) && props.validationErrors.filter(error => error.property === 'name').map(error => error.message)[0]
    const descriptionError = ArrayUtils.isNotEmpty(props.validationErrors) && props.validationErrors.filter(error => error.property === 'description').map(error => error.message)[0]
    const documentationError = ArrayUtils.isNotEmpty(props.validationErrors) && props.validationErrors.filter(error => error.property === 'documentation').map(error => error.message)[0]
    const ownerError = ArrayUtils.isNotEmpty(props.validationErrors) && props.validationErrors.filter(error => error.property === 'owner').map(error => error.message)[0]
    console.log(nameError, descriptionError, documentationError, ownerError)


    const findFieldClass = (fieldValue: string, fieldErrors: string | false) => {
        if (fieldErrors) {
            return "invalid-field"
        }
        return fieldValue ? "valid-field" : "";
    }

    const themeProvider = (theme: MantineTheme) => ({
        color: theme.colorScheme === "dark" ? theme.colors.gray[0] : theme.colors.gray[9],
        '&:hover': {
            backgroundColor: theme.colors.teal[9],
            color: theme.colors.gray[0]
        },
    })

    return (
        <div className="form-group field wizard-content-card" style={{height: '100%'}}>
            <div className="full-width">
                <input type="input" autoFocus={true} value={owner} onChange={addKpiOwner}
                       className={"form-field " + findFieldClass(owner, nameError)}
                       placeholder="What is your name?" name="owner"
                       id='owner' required/>
                {ownerError && <Text color="red">{ownerError}</Text>}
            </div>
            <div className="full-width">
                <input type="input" autoFocus={true} value={kpiName} onChange={addKpiName}
                       className={"form-field " + findFieldClass(kpiName, nameError)}
                       placeholder="What would be the name of your KPI?" name="name"
                       id='name' required/>
                {nameError && <Text color="red">{nameError}</Text>}
            </div>
            <div className="full-width">
                <textarea
                    className={"form-field " + findFieldClass(description, descriptionError)}
                    style={{height: "2rem"}}
                    value={description}
                    placeholder="Please describe your KPI" onChange={addKpiDescription} name="description"
                    id='description'
                    required/>
                {descriptionError && <Text color="red">{descriptionError}</Text>}
            </div>
            <div className="full-width">
                <textarea
                    className={"form-field " + findFieldClass(documentation, documentationError)}
                    style={{height: "2rem"}}
                    value={documentation}
                    placeholder="Please provide your documentation link" onChange={addKpiDocumentation} name="documentation"
                    id='documentation'
                    required/>
                {documentationError && <Text color="red">{documentationError}</Text>}
            </div>
            <Button onClick={()=>{setOpenKPIModal(true)}} color="teal" sx={themeProvider} variant="outline">Load from KPI Registry</Button>
            <PrefillModal 
                opened={openKPIModal}
                setOpened={setOpenKPIModal}
                {...props}
            />
        </div>
    )
}


export default KpiDefinitionStep;